import { Component, Input, OnInit } from '@angular/core';

export class StarInfoPoint {
    i18nTitleKey: string;
    i18nDescriptionKey: string;
}

@Component({
    selector: 'app-star-info',
    templateUrl: './star-info.component.html',
    styleUrls: ['./star-info.component.scss'],
})
export class StarInfoComponent implements OnInit {
    @Input() star1: StarInfoPoint;
    @Input() star2: StarInfoPoint;
    @Input() star3: StarInfoPoint;
    @Input() star4: StarInfoPoint;
    @Input() star5: StarInfoPoint;
    @Input() star6: StarInfoPoint;

    constructor() {}

    ngOnInit(): void {}
}
